export default "__VITE_ASSET__CLgScy9k__"